import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { ModelAuditReportDescriptionProps } from '../types';

const useStyles = makeStyles((theme: any) => ({
  line: {
    marginTop: '4px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: theme.colors.grey[12],
    wordBreak: 'break-word',
  },
}));

/**
 * The backend writes the card text as two lines joined by `\n`:
 * the date range, then the use cases. Render each on its own row.
 */
export const ModelAuditReportDescription = ({
  description,
}: ModelAuditReportDescriptionProps) => {
  const classes = useStyles();
  const lines = (description ?? '').split('\n').filter(line => line.trim());

  return (
    <>
      {lines.map(line => (
        <Typography key={line} className={classes.line}>
          {line}
        </Typography>
      ))}
    </>
  );
};
